import React, {useState} from "react";
import {FormFieldInputNew, useForm, FormFieldUploadFile, Button} from "@netapp/bxp-design-system-react";
import styles from "./GenerateCertificate.module.scss";
import {CsrModal} from "./HttpsModals";
import {useDispatch, useSelector} from "react-redux";
import useErrorContext from "../../../../utils/useErrorContext";
import * as yup from "yup";
import usePermission from "utils/usePermission";
import { useTranslation} from 'react-i18next';
import { connectorsettings as i18nNamespace} from "../../../../i18n/namespace";

const commonNameValidation = (t) => {
    return yup.object().shape({
        commonName: yup
        .string()
        .matches("^((([*|a-z0-9]+(-[a-z0-9]+)*\\.)+[a-z]{2,})|localhost)$", t("enter_valid_dns_names"))
        .required(t("common_name_required"))
    });
};


const Install = ({ configurationLayout = false, secondaryAction = null }) => {
    const installForm = useForm({certificate: null});
    const dispatch = useDispatch();
    const loadCertificate = useSelector(state => state?.connectorSettings?.https?.loadCertificate);
    const { t } = useTranslation(i18nNamespace);
    const hasPermission = usePermission(["https_setup", "httpsetup"]);
    const createHttpSetup = hasPermission({
        permissionType: "create"
    });
    const tooltip = !createHttpSetup ? t("no_permission_for_cvo") : null;

    const {
        handleFormSubmit: handleInstallFormSubmit,
        formState: installFormState
    } = installForm;

    const installCsr = () => {
        dispatch({
            type: "CONNECTOR-SETTINGS:INSTALL-HTTPS-CERTIFICATE",
            payload: {
                occmCertificate: installFormState.certificate.contents
            }
        });
    }
    useErrorContext("HTTPS-INSTALL");
    const installButton = (
        <Button tooltip={tooltip} isSubmitting={loadCertificate} onClick={handleInstallFormSubmit(installCsr)}
                disabled={!createHttpSetup || !installFormState.certificate}>
            {t("install")}
        </Button>
    );

    return <div className={configurationLayout ? styles.configurationInstall : styles["step"]}>
        <div className={styles["https-inputs"]}>
            {!configurationLayout && <div>
                <div className={styles["numberCircle"]}>2</div>
            </div>}
            <FormFieldUploadFile className={styles["FormFieldInputs"]}
                                 form={installForm}
                                 label={t("certificate")}
                                 name="certificate"
                                 placeholder={configurationLayout ? t("upload_a_certificate") : t("file")}
                                 hideText={!configurationLayout}/>
        </div>
        
        {configurationLayout
            ? <div className={styles.configurationActions}>{secondaryAction}{installButton}</div>
            : installButton}
    </div>
}

export default React.memo(({ configurationLayout = false }) => {
    const dispatch = useDispatch();
    const commonName = useSelector(state => state.connectorSettings.https.commonName);
    const generatedCsr = useSelector(state => state.connectorSettings.https.generatedCsr);
    const signedCertificate = useSelector(state => state.connectorSettings.https.signedCertificate);
    const pendingCsr = useSelector(state => state.connectorSettings.https.pendingCsr);
    const generateError = useSelector(state => state.connectorSettings.https.generateError);

    const loadCsr = useSelector(state => state.connectorSettings.https.loadCsr);
    const { t } = useTranslation(i18nNamespace);
    const [viewCsr, setViewCsr] = useState(false);
    const [setRegeneratePrompt] = useState(false);
    const genForm = useForm({commonName: configurationLayout ? '' : commonName}, commonNameValidation(t));
    const {
        handleFormSubmit: handleGenFormSubmit,
        formState: genFormState
    } = genForm;
       const generateCsr = () => {
        dispatch({
            type: "CONNECTOR-SETTINGS:GENERATE-HTTPS-CSR",
            payload: {
                key: "commonName",
                value: genFormState.commonName
            }
        });
        setViewCsr(true);
        setRegeneratePrompt(false);
    }  

    useErrorContext("HTTPS-GENERATE");
    const generateButton = (
        <Button color="secondary" isSubmitting={loadCsr} onClick={handleGenFormSubmit(generateCsr)}
                    disabled={!genFormState.commonName}>
                {t("generate_csr")}
        </Button>

    );

    return <>       
        {viewCsr && !generateError && commonName && !loadCsr &&
        <CsrModal csr={generatedCsr} closeTrigger={() => setViewCsr(false)}/>}
        <div className={configurationLayout ? styles.configurationBase : styles["base"]}>
            <div className={configurationLayout ? styles.configurationCommonName : styles["step"]}>
                <div className={styles["https-inputs"]}>
                    {!configurationLayout && <div>
                        <div className={styles["numberCircle"]}>1</div>
                    </div>}
                    <FormFieldInputNew className={styles["FormFieldInputs"]}
                                       form={genForm}
                                       label={t("common_name")}
                                       name='commonName'
                                       placeholder={configurationLayout ? '' : t("website_example")}/>

                </div>
                {!configurationLayout && generateButton}
            </div>
            <Install
                configurationLayout={configurationLayout}
                secondaryAction={configurationLayout ? generateButton : null}
            />
        </div>
    </>
});